<app-ds-recent-search 
  [dataType]="dataType"
  [destination]="istypeLatLong ? carsSearch?.pickup?.placeName : carsSearch?.pickup?.code | placeName | async"
  [startDate]="formatDate(carsSearch?.pickup?.time)"
  [endDate]="formatDate(carsSearch.dropoff?.time)"
  [activateTooltip]="false"
  (clicked)="searchAutos()">
</app-ds-recent-search>